import { Component } from '@angular/core';

import { EndorsementBase } from '../../models';

@Component({
    selector: 'app-stamp-endorsement',
    templateUrl: './stamp-endorsement.component.html',
    styleUrls: ['./stamp-endorsement.component.scss'],
    standalone: false
})
export class StampEndorsementComponent extends EndorsementBase {

  endorsementClicked(): void {
    this.signEndorsement.emit({
      endorsementLocationId: this.endorsementLocation.documentEndorsementLocationId,
      endorsementType: this.endorsementLocation.endorsementTypeCode,
      packageUserGuid: this.endorsementLocation.packageUserGuid,
    });
  }
}
